/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_YesInputs */

const en_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const es_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const fr_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const ja_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const zh_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是`)
};

const ar_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نعم`)
};

const id_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya`)
};

const it_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì`)
};

const ru_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const pt_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

const ko_val_yes = /** @type {(inputs: Val_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Val_YesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_yes = /** @type {((inputs?: Val_YesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_YesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_yes(inputs)
	if (locale === "es") return es_val_yes(inputs)
	if (locale === "fr") return fr_val_yes(inputs)
	if (locale === "de") return de_val_yes(inputs)
	if (locale === "ja") return ja_val_yes(inputs)
	if (locale === "zh") return zh_val_yes(inputs)
	if (locale === "ar") return ar_val_yes(inputs)
	if (locale === "id") return id_val_yes(inputs)
	if (locale === "it") return it_val_yes(inputs)
	if (locale === "ru") return ru_val_yes(inputs)
	if (locale === "pt") return pt_val_yes(inputs)
	return ko_val_yes(inputs)
});